import { render, staticRenderFns } from "./suobi_chongzhi.vue?vue&type=template&id=056b20f8&scoped=true"
import script from "./suobi_chongzhi.vue?vue&type=script&lang=js"
export * from "./suobi_chongzhi.vue?vue&type=script&lang=js"
import style0 from "./suobi_chongzhi.vue?vue&type=style&index=0&id=056b20f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056b20f8",
  null
  
)

export default component.exports